import { observer } from "mobx-react";
import { StandardDialog } from "@roc/ui";
import { PayoffCalculator } from "./payoffCalculator";
import { Document } from '@roc/feature-types';
import { CustomTaskDialog } from '@roc/feature-general-tasks';

interface Props {
  open: boolean;
  onClose: () => void;
  document: Document;
}

export const PayoffCalculatorDialog = observer(({ open, onClose, document }: Props) => {
  const taskId = document?.taskId;

  return (
    <>
      {taskId ? (
        <CustomTaskDialog
          open={open}
          title="Payoff Calculator"
          maxWidth="xl"
          handleClose={onClose}
          dialogContent={
            <PayoffCalculator />
          }
          taskId={taskId}
        />
      ) : (
        <div>
          <StandardDialog
            open={open}
            title="Payoff Calculator"
            maxWidth="xl"
            handleClose={onClose}
            dialogContent={
              <PayoffCalculator />
            }
          />
        </div >
      )}
    </>

  );
});
